// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__3ijvt","load3":"Spinner_load3__Bakmn"};